module.exports = __webpack_public_path__ + "10_hair_brown.45797db5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/10_hair_brown.png
// module id = SSIL
// module chunks = 0